import { render, staticRenderFns } from "./ModalPaidCustodyCanceled.vue?vue&type=template&id=48be2643&scoped=true"
import script from "./ModalPaidCustodyCanceled.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalPaidCustodyCanceled.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ModalPaidCustodyCanceled.vue?vue&type=style&index=0&id=48be2643&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be2643",
  null
  
)

export default component.exports